import './Style.scss';
import { createPassword } from 'actions/userActions';
import { getLocalization } from 'global/global';
import { StateInterface } from 'Interfaces/StateInterface';
import * as React from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getQueryParams } from 'utils/utils';
import { PasswordInput } from 'views/components/PasswordInput';
import ProgressContainer from 'views/Progress/ProgressContainer';

interface ActionProps {
  createPassword: (account: string, otp: string, password: string) => void;
}

export const CreatePassword = (props: ActionProps) => {
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = React.useState(false);

  const handleInputChange = (e) => {
    if (e.target.name === 'password') {
      setPassword(e.target.value);
    } else if (e.target.name === 'confirmPassword') {
      setConfirmPassword(e.target.value);
    }
  };

  const onChangePassword = () => {
    if (password === '') {
      setPasswordError(true);
    } else if (confirmPassword === '') {
      setConfirmPasswordError(true);
    } else if ((password !== confirmPassword) || ((/[A-Z]/.test(password) === false
    || /[a-z]/.test(password) === false
    || /\d/.test(password) === false
    || /[\W_]/.test(password) === false
    ) && password.length < 10)) {
      setPasswordError(true);
      setConfirmPasswordError(true);
    } else {
      const {c: account, otp} = getQueryParams(window.location.search);
      props.createPassword(account, otp, password);
    }
  };

  return (
    <Container>
      <Row>
        <Col
          md={{
            offset: 3,
            span: 6
          }}
        >
          <h2 className="text-center">{getLocalization('createPassword')}</h2>
          <Form.Group>
            <Form.Label>{getLocalization('password')}</Form.Label>
            <PasswordInput
              passwordError={passwordError}
              value={password}
              onChange={(e) => handleInputChange(e)}
              name="password"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>{getLocalization('confirmPasssword')}</Form.Label>
            <PasswordInput
              passwordError={confirmPasswordError}
              value={confirmPassword}
              onChange={handleInputChange}
              name="confirmPassword"
            />
          </Form.Group>
          <Button
            size="sm"
            onClick={onChangePassword}
          >
            {getLocalization('createPassword')}
          </Button>
          <Container fluid={true} className="password-info">
            <Alert variant={'info'}>
              <p>{getLocalization('passwordRule')}</p>
              <ul>
                <li>{getLocalization('passwordRule1')}</li>
                <li>{getLocalization('passwordRule2')}</li>
              </ul>
            </Alert>
          </Container>
        </Col>
      </Row>
      <ProgressContainer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={true}
        pauseOnHover={true}
        closeButton={false}
      />
    </Container>
  );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<StateInterface, any, AnyAction>): ActionProps => {
  return {
    createPassword: (account, otp, password) => {
      dispatch(createPassword(account, otp, password));
    },
  };
};


export const CreatePasswordApp = withCookies<{}>(
  connect(null, mapDispatchToProps)(CreatePassword));
export default CreatePasswordApp;
